import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from '../../../lib/axios'
import { holidays } from '../../../lib/apiList'
import { HolidayState, AddHoliday } from './types'
import { dateFormat } from '../utils'
import { store } from '../../../redux/store'
import { SHOW_NOTIFICATION } from '../../../redux/slices/showNotificationSlice'

const holidayState: HolidayState = {
    updateState: false,
    loading: false,
    holidayList: [],
    error: '',
    response: '',
    totalCount: 0,
    pageSize: 2,
}

export const editHoliday = createAsyncThunk(
    'holiday/put',
    async (data: AddHoliday) => {
        const response = await axios.put(`${holidays.PUT_HOLIDAY}`, data)
        if (response?.status === 200) {
            store.dispatch(
                SHOW_NOTIFICATION({
                    message: 'Holiday updated successfully',
                    type: 'success',
                })
            )
            store.dispatch(editholiday(data))
        }
        return response.data
    }
)

const holidaySlice = createSlice({
    name: 'holidays',
    initialState: holidayState,
    reducers: {
        holidaylist: (state, action) => {
            state.holidayList = action.payload.data.data
            state.totalCount = action.payload.totalCount
            state.pageSize = action.payload.pageSize
        },
        addholiday: (state, action) => {
            state.response = 'Holiday added successfully'
            const data = action.payload
            const holiday = {
                id: action.payload.id,
                title: data.payload.holidayName,
                holidayDate: dateFormat(data.payload.holidayDate),
                holidayDay: data.dayName,
            }
            state.holidayList.unshift(holiday)
        },
        editholiday: (state, action) => {
            state.response = 'Holiday updated successfully'
            const data = action.payload
            const index = state.holidayList.findIndex(
                (holiday: any) => holiday.id === data.id
            )
            if (index !== -1) {
                state.holidayList[index] = {
                    id: data.id,
                    title: data.holidayName || '',
                    holidayDate: dateFormat(data.holidayDate),
                    holidayDay: data.holidayDay || '',
                }
            }
        },
        delholiday: (state, action) => {
            state.holidayList = state.holidayList.filter(
                (holiday: any) => holiday.id !== action.payload
            )
        },
    },
})

export default holidaySlice.reducer

export const { holidaylist, addholiday, delholiday, editholiday } =
    holidaySlice.actions
